import React, { useState } from "react";
import { useAuthStore } from "../store/store";

export default function CreateInvestmentPlan() {
  const { createInvestmentPlan } = useAuthStore();
  const [planData, setPlanData] = useState({
    investmentPlanName: "",
    interestRate: "",
    investmentLimit: "",
    investmentDuration: "",
    capitalGrowth: "",
    riskLevel: "",
    returns: "",
    investmentPlanDescription: "",
    investmentPlanImage: "",
    totalReturn: "",
  });

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPlanData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMessage("");
    setSuccessMessage("");

    const response = await createInvestmentPlan(planData);
    if (!response) setLoading(false);

    if (response?.data) {
      setSuccessMessage("Investment plan created successfully!");
      setPlanData({
        investmentPlanName: "",
        interestRate: "",
        investmentLimit: "",
        investmentDuration: "",
        capitalGrowth: "",
        riskLevel: "",
        returns: "",
        investmentPlanDescription: "",
        investmentPlanImage: "",
        totalReturn: "",
      });
      setLoading(false);
    }
    if (response?.err)
      throw new Error(response?.err || "Failed to create plan.");
    setLoading(false);
  };

  const inputFields = [
    { label: "Plan Name", name: "investmentPlanName", type: "text" },
    { label: "Interest Rate (%)", name: "interestRate", type: "text" },
    { label: "Investment Limit ($)", name: "investmentLimit", type: "text" },
    { label: "Returns", name: "returns", type: "text" },
    {
      label: "Investment Duration (years)",
      name: "investmentDuration",
      type: "text",
    },
    { label: "Capital Growth (%)", name: "capitalGrowth", type: "text" },
    { label: "Risk Level", name: "riskLevel", type: "text" },
    { label: "Total Return ($)", name: "totalReturn", type: "text" },
    // { label: "Description", name: "investmentPlanDescription", type: "text" },
    // { label: "Image URL", name: "investmentPlanImage", type: "text" },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center p-6">
      <div className="w-full max-w-2xl bg-white rounded-2xl shadow-2xl overflow-hidden transform transition-all hover:scale-105">
        <div className="p-8">
          <h1 className="text-4xl font-bold text-gray-800 mb-6 text-center">
            Create Investment Plan
          </h1>

          {errorMessage && (
            <div className="mb-4 p-3 bg-red-100 text-red-700 rounded">
              {errorMessage}
            </div>
          )}
          {successMessage && (
            <div className="mb-4 p-3 bg-green-100 text-green-700 rounded">
              {successMessage}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-6">
            {inputFields.map(({ label, name, type }) => (
              <div key={name} className="space-y-2">
                <label className="block text-gray-700 text-sm font-medium">
                  {label}
                </label>
                <input
                  type={type}
                  name={name}
                  value={planData[name] || ""}
                  onChange={handleInputChange}
                  required
                  className="w-full p-3 border border-gray-300 rounded-lg bg-white shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                  disabled={loading}
                />
              </div>
            ))}

            <button
              type="submit"
              className={`w-full mt-6 py-3 px-6 rounded-lg shadow-lg transition-all transform ${
                loading
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-gradient-to-r from-blue-600 to-blue-700 text-white hover:from-blue-700 hover:to-blue-800 hover:scale-105 active:scale-95"
              }`}
              disabled={loading}
            >
              {loading ? "Creating..." : "Create Plan"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
